export default "__VITE_ASSET__jXF1BlIC__"